import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Grid from "../assets/Grid.png";
import { motion } from "framer-motion";
import imagw from "../assets/CTA.webp";
// import OurBlog from "./OurBlog";
import Navbar from "./Navbar";
import Footer from "./Footer";
import DiscoverBlogs from "./DiscoverBlogs";

const Contactus = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [openIndex, setOpenIndex] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
    const script = document.createElement("script");
    script.type = "module";
    script.src = "/off_seo.js";
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const faqs = [
    {
      question: "How is Packky (powered by Chaafo) different from other food delivery services?",
      answer:
        "Packky (powered by Chaafo) is a dedicated delivery partner exclusively for restaurants, unlike major aggregators that take a commission on orders. We offer faster deliveries, real-time tracking, lower costs, and full control over your customer experience without third-party interference.",
    },

    {
      question:
        "Does Packky (powered by Chaafo) provide delivery services for all types of restaurants?",
      answer:
        "Yes! Whether you run a fine-dining restaurant, café, cloud kitchen, or quick-service restaurant (QSR), Packky (powered by Chaafo) tailors its delivery solutions to meet your business needs.",
    },

    {
      question:
        "Can I use Packky (powered by Chaafo) without listing my restaurant on third-party platforms?",
      answer:
        "Absolutely! Packky (powered by Chaafo) enables restaurants to deliver directly to customers through their own website, WhatsApp, or social media, eliminating high commissions from food delivery aggregators.",
    },

    {
      question:
        "What happens if a delivery is delayed or an order is incorrect?",
      answer:
        "Packky (powered by Chaafo)’s real-time tracking ensures proactive delivery management. If an order is delayed or incorrect, our dedicated support team intervenes immediately to resolve the issue",
    },

    {
      question: "How does Packky (powered by Chaafo) help increase my restaurant’s order volume?",
      answer:
        "We provide faster deliveries, better customer retention, and brand control—leading to higher customer satisfaction and repeat orders. Plus, our optional marketing services can help drive more traffic to your restaurant.",
    },

    {
      question:
        "Is there a minimum order requirement to use Packky (powered by Chaafo)’s delivery service?",
      answer:
        " No, there is no minimum order restriction. We deliver everything from single meals to large bulk orders, making Packky (powered by Chaafo) ideal for both small and large-scale restaurants.",
    },

    {
      question: "What are the delivery charges, and how is pricing structured?",
      answer:
        "Packky (powered by Chaafo) offers flexible pricing based on delivery distance, order volume, and restaurant needs. Unlike other platforms, we provide transparent pricing with no hidden fees.",
    },

    {
      question:
        "Can I integrate Packky (powered by Chaafo) with my restaurant’s website or WhatsApp ordering system?",
      answer:
        "Yes! Packky (powered by Chaafo) seamlessly integrates with your website, WhatsApp ordering system, and POS software, ensuring smooth order processing and automated delivery scheduling.",
    },

    {
      question:
        "What safety measures does Packky (powered by Chaafo) follow for food handling and delivery?",
      answer:
        " We ensure strict hygiene standards, including: Contactless deliveries, Sanitized delivery bags, Trained riders following food safety protocols, Temperature-controlled food transport for heat-sensitive items",
    },

    {
      question:
        "How do I get started with Packky (powered by Chaafo), and how long does onboarding take?",
      answer:
        "Getting started is easy! Simply sign up on our website or contact our team. We offer a quick onboarding process that takes less than 48 hours, so you can start delivering with Packky (powered by Chaafo) immediately.",
    },
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
      {/* <Navbar /> */}

      <div className="" style={{padding: '7rem 0'}}>
        <section className="contact-section ">
          <h5 className="contact-subtitle " style={{ color: "#AD5BFF" }}>
            CONTACT US
          </h5>

          <h2 className="contact-title1" style={{ fontSize: "28px" }}>
            Got questions? We're here to <br /> listen and help!
          </h2>

          <p className="contact-subtitle1 fs-4">
          From the first idea to full execution, our team is here to support you every step of the way. Whether you want to know more about our delivery solutions, need help with technical queries, or are looking for custom logistics support, just reach out.
          </p>
        </section>

        <div className="contact-container mb-5">
          <div className="Map-card-paccky">
            <div className="card bg-white " style={{ borderRadius: "1rem" }}>
              <div className="row col-12 p-0 m-0">
                <div className="col-12 col-sm-12 col-md-4 p-0 m-0 d-flex align-items-center">
                  <div className="contact-card d-flex flex-row-reverse align-items-center p-3 m-2 contact-column w-100">
                    <div className="contact-text ml-5">
                      <h5 className="fw-bold mb-1 text-start">Call us</h5>
                      <p className="text-secondary mb-0 text-start">
                        +91-9958853167
                      </p>
                    </div>
                    <div className="d-flex justify-content-center align-items-center me-3">
                      <i className="fas fa-phone icon rounded-circle p-3 border border-white bg-warning text-white d-flex justify-content-center align-items-center"></i>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md-4 p-0 m-0 d-flex align-items-center">
                  <div className="contact-card d-flex flex-row-reverse align-items-center p-3 m-2 contact-column w-100">
                    <div className="contact-text ml-5">
                      <h5 className="fw-bold mb-1 text-start">Email us</h5>
                      <p className="text-secondary mb-0 text-start">
                        support@packky.com
                      </p>
                    </div>
                    <div className="d-flex justify-content-center align-items-center me-3">
                      <i className="fas fa-envelope icon rounded-circle p-3 border border-white bg-warning text-white d-flex justify-content-center align-items-center"></i>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md-4 p-0 m-0 d-flex align-items-center">
                  <div className="contact-card d-flex flex-row-reverse align-items-center m-2 p-3 w-100">
                    <div className="contact-text ml-5">
                      <h5 className="fw-bold mb-1 text-start">Visit us</h5>
                      <p className="text-secondary mb-0 text-start">
                        Ithum, Tower-B, 218, Second Floor
                        <br />
                        Sector 62, Noida-201309
                      </p>
                    </div>
                    <div className="d-flex justify-content-center align-items-center me-1">
                      <i className="fas fa-map-marker-alt icon rounded-circle p-3 border border-white bg-warning text-white"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="map-container">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2077.0866157237397!2d77.3721473999647!3d28.62702999649285!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce5f6bf0e729b%3A0x4c68e44d9e70a67f!2sI-Thum%20Tower%20-%20office%20space%20in%20IThum%20Noida%20Sector%2062!5e1!3m2!1sen!2sin!4v1750913054472!5m2!1sen!2sin"
                width="100%"
                height="350px"
                style={{ borderRadius: "20px" }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>

        <div
          className="container-fluid d-flex flex-column"
          style={{
            backgroundImage: `url(${Grid})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundColor: " #EDF3FC",
          }}
        >
          <div className="container py-5">
            <h2 className="text-center text-black mt-4 mb-4">FAQ's</h2>
            <div className="row justify-content-center">
              <div className="col-12 col-md-10 col-lg-8">
                <div className="faq-card p-4 mt-5 rounded bg-white table table-striped">
                  {faqs.map((faq, index) => {
                    const isOpen = openIndex === index;

                    return (
                      <div key={index} className="mb-3">
                        <div
                          className="d-flex justify-content-between align-items-center"
                          onClick={() => toggleFAQ(index)}
                          style={{ cursor: "pointer" }}
                        >
                          <p
                            className="mb-0 fw-normal"
                            style={{ fontSize: "clamp(14px, 4vw, 18px)" }}
                          >
                            {faq.question}
                          </p>

                          <button
                            className="btn d-flex align-items-center justify-content-center"
                            style={{
                              width: "2.5rem",
                              height: "2.5rem",
                              fontSize: "1.875rem",
                            }}
                          >
                            {isOpen ? "-" : "+"}
                          </button>
                        </div>

                        {isOpen && (
                          <div
                            className="p-2 font-sf-pro text-secondary"
                            style={{ fontSize: "clamp(14px, 4vw, 16px)" }}
                          >
                            {faq.answer}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="main-box-5 card-h bg-light p-5"
          style={{ minHeight: "auto" }}
        >
          <section className="about-p">
            <div className="container">
              <div className="row mt-5">
                <div className="col-12">
                  <div
                    className="banner-box3 mx-auto rounded-5 overflow-hidden position-relative"
                    style={{
                      background:
                        "linear-gradient(-135deg, #FDFEFF 20%, #CEEBFF 70%, #129EFF 100%)",
                      border: "0.5px solid #ccc",
                      minHeight: "300px",
                      maxWidth: "1200px",
                      boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                    }}
                  >
                    <div className="row g-0 h-100">
                      <div className="col-lg-7 col-md-6 col-12 d-flex flex-column justify-content-center p-4 p-md-5">
                        <div className="banner-content">
                          <h4
                            className="text-dark fw-bold mb-3"
                            style={{ fontSize: "clamp(18px, 2.5vw, 24px)" }}
                          >
                            Join the Future of Delivery
                          </h4>
                          <p
                            className="mb-0"
                            style={{
                              color: "#6B6B6B",
                              fontSize: "clamp(14px, 1.5vw, 16px)",
                            }}
                          >
                            At Packky (powered by Chaafo), we are more than just a service. We're
                            your logistics partner. We're your partner in need
                            when you're looking for last-mile delivery
                            solutions, fleet management, or the smooth
                            integration of your existing systems.
                          </p>
                          <p
                            className="mb-0"
                            style={{
                              color: "#6B6B6B",
                              fontSize: "clamp(14px, 1.5vw, 16px)",
                            }}
                          >
                            Let's advance the world one delivery at a time.
                          </p>
                          <div className="mt-2">
                            <button
                              className="btn btn-light fw-bold rounded-pill px-4 py-2 d-flex align-items-center"
                              style={{
                                width: "fit-content",
                                marginTop: "15px",
                              }}
                            >
                              <span
                                className="text-primary"
                                style={{ fontSize: "clamp(10px, 1.5vw, 16px)" }}
                              >
                                Sign Up for Free{" "}
                                <i className="fas fa-arrow-right ms-2"></i>
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-5 col-md-6 col-12 d-flex align-items-end justify-content-center position-relative">
                        <img
                          src={imagw}
                          alt="Service"
                          className="img-fluid"
                          style={{
                            maxWidth: "100%",
                            maxHeight: "calc(100% - 20px)",
                            height: "auto",
                            objectFit: "contain",
                            objectPosition: "bottom right",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      <DiscoverBlogs/>
      </div>
      {/* <Footer /> */}
    </>
  );
};

export default Contactus;
